import { cn } from "@/lib/cn";
import type { NombreIcono } from "@/lib/navegacion";

/** Trazos 24×24, stroke del color del texto. Propios: no hay librería de íconos. */
const TRAZOS: Record<NombreIcono, string[]> = {
  inicio: ["M3 11l9-7 9 7", "M5 10v10h14V10", "M10 20v-6h4v6"],
  obra: ["M4 21V9l8-5 8 5v12", "M4 21h16", "M9 21v-5h6v5", "M9 11h6"],
  plata: ["M3 7h18v10H3z", "M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5", "M6 10v4", "M18 10v4"],
  fiduciantes: ["M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6", "M3 20a6 6 0 0 1 12 0", "M16 5.5a3 3 0 0 1 0 5.5", "M17.5 14.5A6 6 0 0 1 21 20"],
  ventas: ["M4 4h8l8 8-8 8-8-8z", "M8.5 8.5h.01"],
  proyecto: ["M6 21V3h12v18", "M3 21h18", "M9 7h2", "M13 7h2", "M9 11h2", "M13 11h2", "M10 21v-4h4v4"],
  configuracion: ["M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6", "M19 12h2M3 12h2M12 3v2M12 19v2M17 7l1.5-1.5M5.5 18.5L7 17M17 17l1.5 1.5M5.5 5.5L7 7"],
  mas: ["M5 12h.01", "M12 12h.01", "M19 12h.01"],
  compartir: ["M12 15V3", "M8 7l4-4 4 4", "M6 11v9h12v-9"],
  agregar: ["M4 4h16v16H4z", "M12 8v8", "M8 12h8"],
  flecha: ["M9 6l6 6-6 6"],
  arrastrar: ["M9 6h.01", "M15 6h.01", "M9 12h.01", "M15 12h.01", "M9 18h.01", "M15 18h.01"],
  comprobante: ["M6 3h8l4 4v14H6z", "M14 3v4h4", "M9 12h6", "M9 16h6"],
  "falta-comprobante": ["M6 3h8l4 4v14H6z", "M14 3v4h4", "M12 10v4", "M12 17h.01"],
  whatsapp: ["M3.5 20.5l1.3-3.9A8.5 8.5 0 1 1 8.1 19.3z", "M9 8.5c0 3.6 2.9 6.5 6.5 6.5l1-1.6-2.2-1.1-1 .9a4.6 4.6 0 0 1-2-2l.9-1-1.1-2.2z"],
};

export function Icono({ nombre, className }: { nombre: NombreIcono; className?: string }) {
  return (
    <svg
      aria-hidden="true"
      data-icono={nombre}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={nombre === "mas" || nombre === "arrastrar" ? 3 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("size-6 shrink-0", className)}
    >
      {TRAZOS[nombre].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
